import uhaulStore from "./CustomRedux/UhaulStore";

function GetLiveChatHeader() {
  const keyName = "Ocp-Apim-Subscription-Key";
  let liveChatHeader = {
    "Content-Type": "application/json",
    "Ocp-Apim-Subscription-Key": ""
  };
  try {
    switch (uhaulStore.getState().UhaulReducer.config.environment) {
      case "DEV":
        liveChatHeader[keyName] = process.env.REACT_APP_LIVE_CHAT_APIM_KEY_DEV;
        break;
      case "QA":
        liveChatHeader[keyName] = process.env.REACT_APP_LIVE_CHAT_APIM_KEY_QA;
        break;
      case "PROD":
        liveChatHeader[keyName] = process.env.REACT_APP_LIVE_CHAT_APIM_KEY_PROD;
        break;
    }
  } catch (e) {
    console.error(e);
  }
  return liveChatHeader;
}

export default GetLiveChatHeader;
